module.exports = ".border{\r\n    border: 1px solid black;\r\n}\r\n.border-left{\r\n    border-left: 1px solid black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manage/products/product-view/product-view.component.css
// module id = ./src/app/pages/manage/products/product-view/product-view.component.css
// module chunks = main